/** `SlotBoundary` (1.I-3 deliverable 4): one slot component's error boundary. */
import { Component, type ErrorInfo, type ReactNode } from 'react';

interface Props {
  readonly slotId: string;
  readonly fallback: ReactNode;
  readonly children: ReactNode;
}

export class SlotBoundary extends Component<Props, { failed: boolean }> {
  override state = { failed: false };

  static getDerivedStateFromError(): { failed: boolean } {
    return { failed: true };
  }

  override componentDidCatch(_error: Error, _info: ErrorInfo): void {
    // Only the slot id: a message may hold a title or text.
    console.error(`slot ${this.props.slotId} failed`);
  }

  override render(): ReactNode {
    return this.state.failed ? this.props.fallback : this.props.children;
  }
}
